import { useMemo } from "react";
import { imageTargets, predictionTargets, locationTargets } from "./mockTargetData";

function getRandomItem<T>(array: T[]): T {
  return array[Math.floor(Math.random() * array.length)];
}

export interface RandomTargetData {
  image: {
    url: string;
    alt: string;
  };
  prediction: {
    optionA: { url: string; label: string };
    optionB: { url: string; label: string };
  };
  location: {
    label: string;
    embedUrl: string;
  };
}

export function useRandomTargetData(): RandomTargetData {
  return useMemo(() => ({
    image: getRandomItem(imageTargets),
    prediction: getRandomItem(predictionTargets),
    location: getRandomItem(locationTargets),
  }), []);
}
